import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/assets/media/ellipse-blur-green-small.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/BranchContacts/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/HideFooterMap.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/common/ImageBg.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-branches/AnswerCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-branches/BranchSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-branches/Media.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-branches/NewsCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/rmk-pilates-front/rmk-pilates-front/src/app/components/page-branches/Reviews.tsx");
